

module.exports = {
    isRoleBranch: () => {
        return localStorage.getItem("login_user_role") == "branch";
    },
    getLoginBranchInfo: () => {
        if (module.exports.isRoleBranch()) {
            const id = localStorage.getItem("login_branch_id");
            const name = localStorage.getItem("login_branch_name");

            return { id, name };
        }
        return null;
    },
    isInternalPage: () => {
        const urlBase = process.env.REACT_APP_BASE_URL;
        const urlInternal = `${urlBase}/internal`;
        
        return window.location.pathname.indexOf(urlInternal) > -1;
    },
    isFullPage: () => {
        const urlBase = process.env.REACT_APP_BASE_URL;
        const urlPage = `${urlBase}/page`;
        const hide = window.location.pathname.indexOf(urlPage) > -1;
        if(hide) {
            console.debug('TAS DEBUG - hide header and menu');
        }
        return hide;
    },
    s2ab: (s) => {
        var buf = new ArrayBuffer(s.length); //convert s to arrayBuffer
        var view = new Uint8Array(buf); //create uint8array as viewer
        for (var i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xff; //convert to octet
        return buf;
    },
    download2Excel: (excelBinary, fileName, mimeType = "application/octet-stream") => {
        module.exports.downloadBlob(new Blob([module.exports.s2ab(excelBinary)], { type: mimeType }), fileName);
    },
    downloadHtml2Png: (dom, fileName) => {
        const htmlToImage = require("html-to-image");
        htmlToImage.toBlob(dom).then((blob) => {
            module.exports.downloadBlob(blob, `${fileName}.png`);
        });
    },
    downloadBlob: (blob, fileName) => {
        if (window.flutter_inappwebview && window.flutter_inappwebview.callHandler) {
            window.flutter_inappwebview.callHandler("onDownload", window.URL.createObjectURL(blob), fileName);
        } else {
            const fileSaver = require("file-saver");
            fileSaver.saveAs(blob, fileName);
        }
    },
    arraySort: (arr, col, dir) => {
    	arr.sort((a, b) => {
            const _desc = (_a, _b) => { return _a>_b?-1:_a<_b?1:0};
            const _asc = (_a, _b) => { return _a>_b?1:_a<_b?-1:0};
        
            if(dir === 'desc') {
                return _desc(a[col], b[col]);
            } else {
                return _asc(a[col], b[col]);
            }
        });
    },
};
